/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Tour, AdminService } from "../../genezio-sdk/westtigermotors";
import { useTranslation } from "react-i18next";
import Calendar from "react-calendar";
import "./../Home/calendar.css";
import "react-calendar/dist/Calendar.css";
import "aos/dist/aos.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";
import { Breadcrumbs } from "../../components/Breadcrumbs";
import dayjs from "dayjs";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";

export function OurTours({ isHomePage = false }: { isHomePage?: boolean }) {
  const { t, i18n } = useTranslation();

  const [tours, setTours] = useState<
    (Tour & {
      endDates: Date[];
    })[]
  >([]);

  // get date from query params
  const urlParams = new URLSearchParams(window.location.search);
  const dateFromUrl = urlParams.get("date");
  const selectedToursFromUrl = urlParams.get("tours");
  const [availableDates, setAvailableDates] = useState<Date[]>([]);

  const [selectedPackage, setSelectedPackage] = useState<string>("");

  const [date, setDate] = useState<Date | null>(
    dateFromUrl ? new Date(parseInt(dateFromUrl)) : new Date()
  );

  const [selectedTours, setSelectedTours] = useState<string[]>(
    selectedToursFromUrl ? selectedToursFromUrl.split(",") : []
  );

  async function goToBookingPage() {
    if (selectedTours.length === 0) {
      alert("Please select at least one tour.");
    }

    if (!date) {
      alert("Please select a date.");
    }

    if (selectedPackage === "") {
      alert("Please select a package.");
    }

    window.location.href = `/checkout/${selectedTours[0]}/${date?.getTime()}/${selectedPackage}?otherTours=${selectedTours
      .filter((id) => id !== selectedTours[0])
      .map((id) => tours.find((tour) => tour.id === id)?.name || "")
      .join(";;")}`;
  }

  useEffect(() => {
    async function getTours() {
      const tours = await AdminService.getTours().catch((err) => {
        console.error(err);
        return [];
      });
      const dates = tours
        .map((tour) => tour.tourDates)
        .flat()
        .map((date) => new Date(date));
      setAvailableDates(dates);
      setTours(
        tours.map((tour) => ({
          ...tour,
          endDates:
            tour.tourDates.map(
              (tourDate) =>
                new Date(
                  new Date(tourDate).setDate(
                    new Date(tourDate).getDate() + tour.numberOfDays - 1
                  )
                )
            ) || [],
          tourDates: tour.tourDates
        }))
      );

      // @ts-ignore
      window.dataLayer = window.dataLayer || [];
      // @ts-ignore
      window.dataLayer.push({ items: null });
      // @ts-ignore
      window.dataLayer.push({
        event: "view_item_list",
        currency: "EUR",
        item_list_name: "OurTours",
        items: tours.map((tour, index) => ({
          item_id: tour.id,
          item_name: tour.name,
          item_category: tour.startLocation,
          item_variant: "",
          price: tour.packages[0].price,
          quantity: 1,
          index: index + 1
        }))
      });
    }

    getTours();
  }, []);

  return (
    <>
      {!isHomePage && (
        <>
          {localStorage.getItem("i18nextLng") === "ro" ? (
            <Helmet>
              <link
                rel="canonical"
                href={`https://firstgearclub.com/tururile-noastre`}
              />

              <link
                rel="alternate"
                hrefLang="ro"
                href={`https://firstgearclub.com/tururile-noastre`}
              />
              <link
                rel="alternate"
                hrefLang="en"
                href={`https://firstgearclub.com/tururile-noastre?lang=en`}
              />

              <title>
                Tururi off-road 4x4 cu ghid - Descopera circuitele - First Gear
                Club
              </title>
              <meta
                name="description"
                content="Descopera tururile off-road oferite de First Gear Club si exploreaza peisajele spectaculoase ale Romaniei, de la paduri dense la trasee montane stancoase ⭐ Aventura garantata ⭐ Plecari din Bucuresti & Brasov"
              />
            </Helmet>
          ) : (
            <Helmet>
              <link
                rel="canonical"
                href={`https://firstgearclub.com/tururile-noastre`}
              />

              <link
                rel="alternate"
                hrefLang="ro"
                href={`https://firstgearclub.com/tururile-noastre`}
              />
              <link
                rel="alternate"
                hrefLang="en"
                href={`https://firstgearclub.com/tururile-noastre?lang=en`}
              />

              <title>
                Guided 4x4 Off-Road Tours - Discover the Routes - First Gear
                Club
              </title>
              <meta
                name="description"
                content="Discover the off-road tours offered by First Gear Club and explore Romania's spectacular landscapes, from dense forests to rocky mountain trails ⭐ Guaranteed adventure ⭐ Tours from Bucharest & Brasov."
              />
            </Helmet>
          )}
        </>
      )}

      {!isHomePage && (
        <Breadcrumbs
          items={[
            {
              link: `#`,
              name: `${t("tourPage.allToursH1")}`
            }
          ]}
          isH1={true}
          title={`${t("tourPage.allToursH1")}`}
        />
      )}
      <section className="">
        <div className="container">
          {/* Heading title*/}
          <div className="section-heading">
            <Row className="justify-content-center">
              <Col md={10} className="col-12">
                {!isHomePage ? (
                  // <h1 className="primaryFont">
                  //   {date
                  //     ? t("home.subSearchSection.titleAvailable")
                  //     : t("home.subSearchSection.title")}
                  // </h1>
                  <></>
                ) : (
                  <h2 className="primaryFont">
                    {date
                      ? t("home.subSearchSection.titleAvailable")
                      : t("home.subSearchSection.title")}
                  </h2>
                )}
                {/* <p className="w-100" style={{ maxWidth: "inherit" }}>
                  {t("home.subSearchSection.text")}
                </p> */}
              </Col>
            </Row>
          </div>
          {/* /Heading title */}
          {!isHomePage && (
            <Row className="align-items-start justify-content-between px-2">
              <div className="col-12 col-md-5">
                <div className="input-block p-0">
                  <label className="label-custom-search-home">
                    {t("home.search.selectDateActivities")}
                  </label>
                </div>
                <div className="input-block-wrapp">
                  <div className="input-block date-widget w-100 p-0">
                    <div className="group-img w-100">
                      <div
                        className="calendar-container w-100"
                        // onMouseEnter={() => setHovered(true)}
                        // onMouseLeave={() => setHovered(false)}
                      >
                        {/* {hovered && (
                          <div className="calendar-popup">
                            <button
                              type="button"
                              className="btn-close float-end"
                              aria-label="Close"
                              onClick={() => setHovered(false)}
                            ></button> */}

                        <Calendar
                          value={date}
                          onChange={(e) => {
                            const localDate = e as Date;
                            if (!localDate) {
                              setDate(null);
                              return;
                            }

                            setDate(
                              new Date(
                                Date.UTC(
                                  localDate.getFullYear(),
                                  localDate.getMonth(),
                                  localDate.getDate()
                                )
                              )
                            );
                          }}
                          minDate={
                            new Date(
                              new Date().setDate(new Date().getDate() + 1)
                            )
                          }
                          className="w-100"
                          tileClassName={(elems) => {
                            const localDate = elems.date as Date;
                            const view = elems.view;
                            if (view !== "month") {
                              return "";
                            }

                            const indexOfSelected = availableDates.findIndex(
                              (d) =>
                                dayjs(d).format("YYYY-MM-DD") ===
                                dayjs(date).format("YYYY-MM-DD")
                            );
                            if (
                              indexOfSelected >= 0 &&
                              dayjs(availableDates[indexOfSelected]).format(
                                "YYYY-MM-DD"
                              ) === dayjs(localDate).format("YYYY-MM-DD")
                            ) {
                              return "active-date";
                            }

                            const indexAvailable = availableDates
                              .map((d) => dayjs(d).format("YYYY-MM-DD"))
                              .indexOf(dayjs(localDate).format("YYYY-MM-DD"));

                            if (indexAvailable >= 0) {
                              return `highlight-date`;
                            }

                            return "disabled-date";
                          }}
                          showNeighboringMonth={false}
                        />
                        {/* </div> 
                        )}
                        <div className="hover-target w-100">
                          {date?.toDateString() ||
                            t("home.search.openCalendar")}
                        </div>*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-block p-0">
                  <label className="label-custom-search-home">
                    {t("home.search.selectPackageActivities")}
                  </label>
                </div>
                <div className="delivery-tab">
                  <ul className="nav d-flex flex-column">
                    <li>
                      {tours.length > 0 &&
                        tours[0].packages.map((p) => (
                          <label
                            className="booking_custom_check mb-2"
                            key={p.name}
                          >
                            <input
                              type="radio"
                              name="rent_type"
                              style={{ display: "none" }}
                              onChange={() => setSelectedPackage(p.name)}
                              checked={selectedPackage === p.name}
                            />
                            <div className="booking_checkmark d-flex flex-column align-items-start">
                              <div className="d-flex flex-row justify-content-between w-100">
                                <span className="checked-title">{p.name}</span>
                                <div
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "1.2rem"
                                  }}
                                >
                                  {/* {p.oldPrice ? (
                                    <span
                                      className="text-decoration-line-through me-2 "
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: "1rem"
                                      }}
                                    >
                                      €{p.oldPrice}
                                    </span>
                                  ) : null}{" "} */}
                                  € {p.price}
                                </div>
                              </div>
                              <div className="d-flex flex-row justify-content-between w-100">
                                <div className="d-flex align-items-center">
                                  <ImageWithBasePath
                                    src="assets/img/specification/specification-icon-6.svg"
                                    alt="Icon"
                                    height={15}
                                    className="me-1"
                                  />
                                  <span>
                                    {p.rides === 1
                                      ? t("tourPage.driver1Label")
                                      : `${p.rides} ${t("tourPage.driverOtherLabel")}`}
                                  </span>
                                </div>
                                <div className="d-flex align-items-center">
                                  <ImageWithBasePath
                                    src="assets/img/specification/specification-icon-1.svg"
                                    alt="Icon"
                                    height={15}
                                    className="me-1"
                                  />
                                  {p.vehicles === 0.5 ? "1/2" : p.vehicles}{" "}
                                  {p.vehicles > 1
                                    ? `${t("tourPage.vehicleLabel_other")}`
                                    : `${t("tourPage.vehicleLabel_one")}`}
                                </div>
                              </div>
                            </div>
                          </label>
                        ))}
                    </li>
                  </ul>
                </div>
              </div>
              {selectedTours.length > 0 && (
                <div className="column-group-last p-1 col col-md-12">
                  <div className="input-block">
                    <div className="search-btn mt-0">
                      <button
                        className="btn search-button"
                        disabled={
                          selectedTours.length === 0 ||
                          !date ||
                          selectedPackage === ""
                        }
                        style={{
                          backgroundColor: "#dd000b",
                          border: "1px solid #dd000b",
                          boxShadow: "inset 0 0 0 #ffffff",
                          color: "#ffffff",
                          width: "100%",
                          padding: "10px 12px"
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          if (!date) {
                            alert(t("home.search.searchNoDateAlert"));
                          }
                          // search();
                          goToBookingPage();
                        }}
                      >
                        <i className="fa fa-search" aria-hidden="true" />
                        {t("home.search.searchLabel")}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </Row>
          )}
          <Row>
            {!isHomePage && (
              <div className="input-block p-0 ps-3">
                <label className="label-custom-search-home">
                  {t("home.search.selectToursActivities")}
                </label>
              </div>
            )}
            {tours

              .filter((tour) => {
                // if (!isHomePage) {
                //   return true;
                // }
                return tour.tourDates.length > 0 && tour.numberOfDays === 1;
              })
              .map((tour, index) => (
                <Col
                  md={4}
                  className={`col-12 rental-car-item mb-3`}
                  key={tour.id}
                  onClick={() => {
                    if (isHomePage) {
                      return;
                    }
                    // check if tour.id in selectedTours and remove it, if not add it
                    if (!tour.id) return;
                    if (selectedTours.includes(tour.id)) {
                      setSelectedTours(
                        selectedTours.filter((id) => id !== tour.id)
                      );
                    } else {
                      setSelectedTours([...selectedTours, tour.id]);
                    }
                  }}
                >
                  <div
                    className={`listing-item mb-0 tour-item-custom ${selectedTours.includes(tour.id || "") ? "selected" : ""}`}
                  >
                    <div className="listing-img">
                      {isHomePage ? (
                        <a
                          href={`/tur/${tour?.name.replaceAll(" ", "-")}-${tour.id}/${date ? `${date.getTime()}/` : ""}`}
                          onClick={() => {
                            // @ts-ignore
                            window.dataLayer = window.dataLayer || [];
                            // @ts-ignore
                            // @ts-ignore
                            window.dataLayer.push({ items: null });
                            // @ts-ignore
                            window.dataLayer.push({
                              event: "select_item",
                              currency: "EUR",
                              item_list_name: "OurTours",
                              items: [
                                {
                                  item_id: tour.id,
                                  item_name: tour.name,
                                  item_category: tour.startLocation,
                                  item_variant: "",
                                  price: tour.packages[0].price,
                                  quantity: 1,
                                  index: index + 1
                                }
                              ]
                            });
                          }}
                        >
                          <img
                            src={`${process.env.REACT_APP_STORAGE_BASE_URL}/tours/${tour?.id}/${tour?.photos[0]}`}
                            className="img-fluid"
                            alt={tour.name}
                            loading="lazy"
                          />
                        </a>
                      ) : (
                        <img
                          src={`${process.env.REACT_APP_STORAGE_BASE_URL}/tours/${tour?.id}/${tour?.photos[0]}`}
                          className="img-fluid"
                          alt={tour.name}
                          loading="lazy"
                        />
                      )}
                    </div>
                    <div className="listing-content">
                      <div className="listing-features">
                        {isHomePage && (
                          <div className="fav-item-rental">
                            <div
                              className="featured-text"
                              style={{ background: `#${tour.color}` }}
                            >
                              {t("home.tourSection.featureText")}{" "}
                              {/* {tour.packages[0].oldPrice ? (
                                <span
                                  className="text-decoration-line-through"
                                  style={{
                                    fontWeight: "bold"
                                  }}
                                >
                                  €{tour.packages[0].oldPrice}
                                </span>
                              ) : null}{" "} */}
                              €{tour.packages[0].price}
                            </div>
                          </div>
                        )}
                        <div className="list-rating">
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <i className="fas fa-star filled" />
                          <span>(5.0)</span>
                        </div>
                        <h2 className="listing-title">
                          {isHomePage ? (
                            <a
                              href={`/tur/${tour?.name.replaceAll(" ", "-")}-${tour.id}/`}
                            >
                              {i18n.language === "ro" ? tour.nameRo : tour.name}
                            </a>
                          ) : (
                            <>
                              {i18n.language === "ro" ? tour.nameRo : tour.name}{" "}
                            </>
                          )}
                        </h2>
                        <p>
                          <i className="feather icon-map-pin me-2" />
                          {t("home.tourSection.startLocationLabel")}:{" "}
                          <b>{tour.startLocation}</b>
                        </p>
                        <p>
                          <i className="feather icon-clock me-2" />
                          {t("home.tourSection.durationLabel")}:{""}
                          <b>
                            {" "}
                            {tour.numberOfDays}{" "}
                            {tour.numberOfDays === 1
                              ? t("home.tourSection.numberOfDaysLabel_one")
                              : t("home.tourSection.numberOfDaysLabel_other")}
                            {tour.tourDates.length === 0
                              ? " - By Request"
                              : undefined}
                          </b>
                          {date && tour.numberOfDays > 1 ? (
                            <span className="text-danger">
                              {" "}
                              {t("home.tourSection.warningDifferentDate")}
                            </span>
                          ) : (
                            ""
                          )}
                          {isHomePage && (
                            <>
                              <br />
                              <a
                                href={`/tur/${tour?.name.replaceAll(" ", "-")}-${tour.id}/${date ? `${date.getTime()}/` : ""}`}
                                className=""
                                style={{
                                  fontSize: "0.8rem"
                                }}
                                rel="noreferrer"
                                onClick={() => {
                                  // @ts-ignore
                                  window.dataLayer = window.dataLayer || [];
                                  // @ts-ignore
                                  // @ts-ignore
                                  window.dataLayer.push({ items: null });
                                  // @ts-ignore
                                  window.dataLayer.push({
                                    event: "select_item",
                                    currency: "EUR",
                                    item_list_name: "OurTours",
                                    items: [
                                      {
                                        item_id: tour.id,
                                        item_name: tour.name,
                                        item_category: tour.startLocation,
                                        item_variant: "",
                                        price: tour.packages[0].price,
                                        quantity: 1,
                                        index: index + 1
                                      }
                                    ]
                                  });
                                }}
                              >
                                {t("home.tourSection.buttonLabel")}
                              </a>
                            </>
                          )}
                        </p>
                      </div>
                      <div className="listing-button">
                        {isHomePage ? (
                          <a
                            href={`/tur/${tour?.name.replaceAll(" ", "-")}-${tour.id}/${date ? `${date.getTime()}/` : ""}`}
                            className="btn btn-order"
                            rel="noreferrer"
                            onClick={() => {
                              // @ts-ignore
                              window.dataLayer = window.dataLayer || [];
                              // @ts-ignore
                              // @ts-ignore
                              window.dataLayer.push({ items: null });
                              // @ts-ignore
                              window.dataLayer.push({
                                event: "select_item",
                                currency: "EUR",
                                item_list_name: "OurTours",
                                items: [
                                  {
                                    item_id: tour.id,
                                    item_name: tour.name,
                                    item_category: tour.startLocation,
                                    item_variant: "",
                                    price: tour.packages[0].price,
                                    quantity: 1,
                                    index: index + 1
                                  }
                                ]
                              });
                            }}
                          >
                            {t("home.tourSection.buttonLabel")}
                          </a>
                        ) : (
                          <button className="btn btn-order" rel="noreferrer">
                            {selectedTours.includes(tour.id || "")
                              ? "Deselect"
                              : "Select"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
          </Row>
          {!isHomePage && (
            <Row className="px-4">
              <div className="column-group-last p-1 col col-md-12">
                <div className="input-block">
                  <div className="search-btn mt-0">
                    <button
                      className="btn search-button"
                      disabled={
                        selectedTours.length === 0 ||
                        !date ||
                        selectedPackage === ""
                      }
                      style={{
                        backgroundColor: "#dd000b",
                        border: "1px solid #dd000b",
                        boxShadow: "inset 0 0 0 #ffffff",
                        color: "#ffffff",
                        width: "100%",
                        padding: "10px 12px"
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        if (!date) {
                          alert(t("home.search.searchNoDateAlert"));
                        }
                        // search();
                        goToBookingPage();
                      }}
                    >
                      <i className="fa fa-search" aria-hidden="true" />
                      {t("home.search.searchLabel")}
                    </button>
                  </div>
                </div>
              </div>
            </Row>
          )}
        </div>
      </section>
    </>
  );
}
